<script lang="ts">
  import { Sun, Moon, Menu } from '@lucide/svelte';
  import { Button } from '@aatmanova/ui';

  interface Props {
    theme: string;
    toggleTheme: () => void;
    drawerId?: string;
  }

  let { theme, toggleTheme, drawerId }: Props = $props();
</script>

<!-- Dashboard Top Header Bar -->
<header class="border-b border-base-300 bg-base-100/80 backdrop-blur-md px-4 md:px-8 py-4 flex items-center justify-between sticky top-0 z-30">
  <div class="flex items-center gap-3">
    {#if drawerId}
      <label for={drawerId} class="btn btn-ghost btn-sm btn-circle lg:hidden text-base-content hover:bg-base-200 flex items-center justify-center cursor-pointer" aria-label="Open menu">
        <Menu class="w-5 h-5" />
      </label>
    {/if}
    <span class="w-2 h-2 rounded-full bg-success animate-pulse"></span>
    <span class="text-xs font-semibold tracking-widest uppercase text-base-content/70">Environment Live</span>
  </div>

  <div class="flex items-center gap-4">
    <!-- Light/Dark Toggle Button -->
    <Button
      onclick={toggleTheme}
      variant="ghost"
      size="sm"
      class="btn-circle text-base-content hover:bg-base-200"
    >
      {#if theme === 'dark'}
        <Sun class="w-5 h-5 text-accent" />
      {:else}
        <Moon class="w-5 h-5 text-text-secondary" />
      {/if}
    </Button>

    <div class="text-xs text-base-content/50 font-mono">
      Control Plane v1.0.0
    </div>
  </div>
</header>
